import { BodyText } from '@if/mui'
import { useTranslation } from 'react-i18next'

const ApplicationError = () => {
  const { t } = useTranslation()
  return <BodyText>{t('viewCreditApplication.error')}</BodyText>
}

export default ApplicationError
